/* eslint-disable react/prop-types */
import React, { useContext, useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LettersContainerHeader from '@/views/pages/Letters/elements/LettersContainerHeader';
import LettersItem from '@/views/pages/Letters/elements/LettersItem';
import Spinner from '@/views/components/Spinner/Spinner';

import { TextContext } from '@/utils/contexts/TextContext';
import { ModalContext } from '@/utils/contexts/ModalContext';

const LettersContainer = ({ 
	lettersData,
	isLoading,
	reloadLettersList = null,
}) => {
	const { dict } = useSelector((state) => state.app);
	const navigate = useNavigate();

	const { contextState, contextDispatch } = useContext(TextContext);
	const { showModal } = useContext( ModalContext );

	const [ enteredEditMode, setEnteredEditMode ] = useState(false);

	useEffect(() => {
		if (contextState.editLetterMetadata && !enteredEditMode) {
			setEnteredEditMode(true);
		}
		if (!contextState.editLetterMetadata && enteredEditMode) {
			setEnteredEditMode(false);
			if (reloadLettersList) reloadLettersList();
		}
	}, [ contextState.editLetterMetadata ]);

	const onEditItem = useCallback((item) => {
		contextDispatch({type: 'setEditLetterMetadata', payload: {
			editLetterMetadata: true,
			letterData: item,
		}});
	}, []);

	const onDeleteItem = useCallback( (item) => {
		showModal({
			componentName: 'ModalDeleteLetter',
			additionalInfo: {
				id: item.id,
			},
		});
	}, []);

	const onCreateTemplate = useCallback((itemId) => {
		navigate(`/create-template/${itemId}`);
	}, []);

	return (
		<section className='table__container'>
			<LettersContainerHeader />
			{ lettersData && !isLoading && lettersData.map((it, index) => {
				return (
					<LettersItem
						key={ it.title + index }
						data={ it }
						onDeleteItem={ onDeleteItem }
						onEditItem={ onEditItem }
						onCreateTemplate={ onCreateTemplate }
					/>
				);

			})}
			{ (!lettersData || isLoading) && (
				<Spinner addClass='table__spinner' />
			)}
			{ lettersData && lettersData.length === 0 && (
				<div className='table__no-elements'>
					{ dict.letters.noElements }
				</div>
			)}
		</section>
	);
};
export default LettersContainer;